import useCrud from "../hooks/useCrud";

const useCrudFactory = (endpoint) => {
  const {
    createData,
    updateData,
    deleteData,
    getDataById,
    setActivationState,
    loading,
    error,
    fieldErrors,
    data,
    setData,
    fetchData,
    setFlags,
  } = useCrud(endpoint);

  return {
    createData,
    updateData,
    deleteData,
    getDataById,
    setActivationState,
    loading,
    error,
    fieldErrors,
    data,
    setData,
    fetchData,
    setFlags,
  };
};

export default useCrudFactory;
